import { render, staticRenderFns } from "./WaGroupEdit.vue?vue&type=template&id=4e6d22f3&scoped=true"
import script from "./WaGroupEdit.vue?vue&type=script&lang=js"
export * from "./WaGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./WaGroupEdit.vue?vue&type=style&index=0&id=4e6d22f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d22f3",
  null
  
)

export default component.exports